<template>
  <div
    class="pay-page-component"
    v-if="Object.keys(order).length"
  >
    <div class="container container-pay-page">
      <div
        v-if="showIpadInfo()"
        class="ipad-info-card"
      >提示：此订单包含贵重实物赠品，订单支付完成后，请在订单列表页确认收货地址哦！</div>
      <order-title
        :payOrderView="order.payOrderView"
        :realPrice="realPrice"
        :coupons="coupons"
      ></order-title>
      <pay-channel
        v-show="!showQrModule && !ariwallexPaying"
        :list="payChannelList"
        :activeChannel="activeChannel"
        :realPrice="realPrice"
        @changeChannel="changeChannel"
      ></pay-channel>
      <!-- <template v-if="order.payOrderView.versions.length && activeChannel.code"> -->
      <pay-city
        v-show="order.payOrderView.canChangeLocation && !showQrModule"
        :cityList="cityList"
        :payOrderId="orderInfo.payOrderId"
        :location="order.payOrderView.location"
        :locationName="order.payOrderView.locationName"
        @init="init"
      ></pay-city>
      <ag
        v-show="!showQrModule && agreementList.length && !ariwallexPaying"
        :versions="order.payOrderView.versions"
        :channel="activeChannel.code"
        :studentId="order.studentId"
        :paymentSubject="order.paymentSubjectName"
        :checked.sync="checkedAgreement"
        :vs="agreementList"
        :serialNumber="order.payOrderView.serialNumber"
      />
      <!-- </template> -->
      <div
        class="pay-module"
        v-show="!showQrModule && !ariwallexPaying"
      >
        <vk-btn
          v-show="!ariwallexPaying"
          @click="goToPay"
          size="large"
        >确认支付</vk-btn>
      </div>
      <div class="airwallex-pay-panel" v-show="ariwallexPaying">
        <div class="loading" v-loading="airwallexPreparing"></div>
        <div id="dropIn" :style="{display: 'none'}"></div>
      </div>
      <div v-show="ariwallexPaying" class="pay-back" @click="airwallexBack">选择其他支付方式</div>
    </div>

    <!-- 交通银行隐藏form -->
    <form
      class="form-hide"
      ref="jtForm"
      action="https://payment.bankcomm.com/cashier/ac/authentication.html"
      method="post"
    >
      <input
        type="text"
        id="orderContName"
        name="OrderCont"
        v-model="jtForm.OrderCont"
      />
    </form>

    <!-- 各种分期隐藏的二维码 ， 共用一个-->
    <div
      v-if="showQrModule"
      class="container qrcode-container"
    >
      <div class="zs-qrcode-module">
        <div class="qr-title">{{qrModuleObj[activeChannel.code].title}}</div>
        <div class="qr-content clearfix">
          <div
            class="fl"
            style="width: 300px"
          >
            <div class="qr-module">
              <qr-code ref="qrCode"></qr-code>
            </div>
            <div class="qr-info">
              <i></i>
              <span v-html="qrModuleObj[activeChannel.code].info"></span>
            </div>
          </div>
          <div
            class="zs-info fr"
            v-if="activeChannel.code !== 'ALIPAY'"
          >
            <img
              class="zs-img"
              v-if="activeChannel.code === 'CMB_INSTALMENT'"
              src="@/assets/images/order/zs-info.png"
            />
            <img
              class="wx-img"
              v-if="activeChannel.code === 'WEBANK_INSTALMENT' || activeChannel.code === 'WECHATPAY' || activeChannel.code === 'HUIMIN_INSTALMENT'"
              src="@/assets/images/order/wld-wx-info.png"
            />
          </div>
        </div>
        <div
          class="go-back"
          @click="goBack"
        >选择其他支付方式</div>
      </div>
    </div>

    <!-- 工商支付隐藏form -->
    <form
      class="form-hide"
      ref="gsForm"
      action="https://b2c.icbc.com.cn/servlet/ICBCINBSEBusinessServlet"
      method="post"
    >
      <input
        name="interfaceName"
        v-model="gsForm.interfaceName"
      />
      <input
        name="interfaceVersion"
        v-model="gsForm.interfaceVersion"
      />
      <input
        name="tranData"
        v-model="gsForm.tranData"
      />
      <input
        name="merSignMsg"
        v-model="gsForm.merSignMsg"
      />
      <input
        name="merCert"
        v-model="gsForm.merCert"
      />
    </form>

    <!-- 花呗支付 后端返回的是整个form表单结构， 包含了form 、input -->
    <!-- 还用于云闪付 -->
    <div
      class="form-hide"
      id="hb-form"
    ></div>

    <ping-pay-result-dialog
      :visible.sync="pingPayResultDialogVisible"
      @repeatPay="goToPay"
    ></ping-pay-result-dialog>

    <eggs-dialog
      :visible.sync="eggsDialogVisible"
      :url="eggsBg"
    ></eggs-dialog>
  </div>
</template>

<script>
import orderTitle from './components/orderTitle'
import payChannel from './components/payChannel'
import ag from './components/ag'
import pingPayResultDialog from './components/pingPayResultDialog'
import qrCode from '@/components/qrCode.vue'
import eggsDialog from '../components/eggsDialog.vue'
import pingpp from 'pingpp-js'
import payCity from './components/payCity'
import { createElement, loadAirwallex } from 'airwallex-payment-elements'

export default {
  components: {
    orderTitle, payChannel, ag, qrCode, pingPayResultDialog, eggsDialog, payCity
  },
  data() {
    return {
      orderInfo: {}, // 从订单列表页面传过来的订单信息
      order: {}, // 通过接口获取到的订单详情对象
      payChannelList: [], // 根据订单获取到的支付渠道
      activeChannel: {},  // 当前活动的渠道对象
      coupons: [], // 优惠券
      realPrice: '', // 真实价格
      checkedAgreement: false,
      showQrModule: false, // 是否显示二维码
      // 显示二位码不同对象的文案
      qrModuleObj: {
        'CMB_INSTALMENT': {
          title: '招商银行信用卡支付',
          info: '请使用招行掌上生活扫一扫<br>有效期2小时'
        },
        'WEBANK_INSTALMENT': {
          title: '微粒贷分期支付',
          info: '请使用微信扫一扫<br>有效期30分钟'
        },
        'WECHATPAY': {
          title: '微信支付',
          info: '请使用微信扫一扫<br>有效期2小时'
        },
        'HUIMIN_INSTALMENT': {
          title: '交行惠民贷支付',
          info: '请使用微信扫一扫<br>有效期1小时'
        },
        'ALIPAY': {
          title: '支付宝扫码支付',
          info: '请使用支付宝扫一扫<br>有效期2小时'
        }
      },
      // 支付时调用的方法， 在goToPay()中直接取当前 activeChannel.code 对应此对象中的key进行调用
      payMethodMap: {
        'BCM_INSTALMENT': this.jtPay, // 交通支付 
        'BAIDU_INSTALMENT': this.bdPay, // 百度金融分期
        'CMB_INSTALMENT': this.zsInstallmentPay, // 招商银行分期
        'CMB_PC_QR': this.zsPay, // 招商银行pc扫码
        'WEBANK_INSTALMENT': this.wldPay, // 微粒贷
        'ICBC_INSTALMENT': this.gsPay, // 工商
        'ALIPAYHB_INSTALMENT': this.hbPay, // 花呗分期
        'ALIPAY': this.zfbPay, // 支付宝
        'WECHATPAY': this.wxPay,// 微信
        'UNIONPAY': this.ylPay, // 银联
        'ZHONGJIN_CLOUDFLASH': this.ysfPay, // 云闪付
        'HUIMIN_INSTALMENT': this.hmdPay, // 惠民贷
        'AIRWALLEX_CARD': this.airwallexPay, // Airwallex
        'AIRWALLEX_ALIPAY': this.airwallexPay, // Airwallex
        'AIRWALLEX_WECHAT': this.airwallexPay, // Airwallex
      },
      // 交通银行分期隐藏form 表单
      jtForm: {
        OrderCont: ''
      },
      // 工商银行分期隐藏form 表单值
      gsForm: {
        interfaceName: '',
        interfaceVersion: '',
        tranData: '',
        merSignMsg: '',
        merCert: ''
      },
      pingPayResultDialogVisible: false,
      qrPayCheck: null, // 定时刷新状态的全局对象
      eggsDialogVisible: false,
      eggsBg: '',
      windowTager: null,
      agreementList: [],
      cityList: [],
      ariwallexPaying: false,
      airwallexPreparing: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.orderInfo = this.$route.params
      this.getOrderDetail()
      this.getPayChannel()
      this.getCityList()
    },
    // 是否显示贵重信息提醒
    showIpadInfo() {
      return this.order.payOrderView.versions.some(v => {
        return ['ex-ipad', 'ex-ipad-201901'].includes(v)
      })
    },
    // 获取页面详情 => 订单
    getOrderDetail() {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/pc/detail',
        params: this.orderInfo
      }).then(res => {
        if (res.data.code === 200) {
          // 如果versions中含有vt ， 剔除即可，这个对前端没用，还会影响协议展示  
          const index = res.data.data.payOrderView.versions.indexOf('vt')
          if (index > -1) {
            res.data.data.payOrderView.versions.splice(index, 1)
          }
          this.order = res.data.data
        }
      })
    },
    // 获取渠道
    getPayChannel() {
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/pay/channel',
        params: {
          payOrderId: this.orderInfo.payOrderId,
          version: '',
          source: 'PC',
          device: 'PC',
          t: new Date().getTime(),
        }
      }).then(res => {
        if (res.data.code === 200) {
          res.data.data.forEach(obj => {
            if (obj.prices && obj.prices.length) {
              obj.prices.forEach((o, i) => {
                o.checked = !i
              })
            }
          })
          this.payChannelList = res.data.data
          this.activeChannel = this.payChannelList[0]
          this.getRealPrice()
        }
      })
    },
    // 获取渠道对应的真实价格
    getRealPrice() {
      this.realPrice = ''
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/pay/couponforchannel',
        params: {
          payOrderId: this.orderInfo.payOrderId,
          channel: this.activeChannel.code,
          t: new Date().getTime()
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.coupons = res.data.data.coupons
          // 以下是旧项目原注释：
          //因为历史原因，百度分期的实际支付金额不一定与订单的实付金额相同，所以以channel中的realPayPrice为主
          this.realPrice = this.activeChannel.code === 'BAIDU_INSTALMENT' ? this.activeChannel.prices[0].realPayPrice : res.data.data.realPrice
        }
      })
    },
    // 用户改变渠道
    changeChannel(o) {
      if (this.activeChannel.code === o.code) {
        return
      }
      this.activeChannel = o
      this.checkedAgreement = false
      this.getRealPrice()
    },
    // 点击确认支付
    goToPay() {
      // 如果没有协议 或 协议中是 ‘vt’  或  选中了同意协议  ps： 当没有协议需要展示时，后端可能返回'vt'
      if (!this.agreementList.length || this.checkedAgreement) {
        typeof this.payMethodMap[this.activeChannel.code] === 'function' && this.payMethodMap[this.activeChannel.code]()
      } else {
        this.$alert('请阅读并同意相关服务协议')
      }
    },
    // 大部分走的支付接口
    payMethod(callback, params) {
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/instrument',
        params: params || this.getData(),
      }).then(res => {
        if (res.data.code === 200) {
          // 支付回调
          typeof callback === 'function' && callback(res.data)
        } else {
          this.$alert(res.data.msg)
        }
      })
    },
    // 获取支付协议的id
    getPaymentAgId() {
      const index = this.agreementList.findIndex(o => {
        return o.versionType === 'payment'
      })
      return index > -1 ? this.agreementList[index].id : ''
    },
    // 走payMethod 通用接口时，获取支付参数的方法
    getData() {
      const params = {
        channel: this.activeChannel.code,
        payOrderId: this.order.payOrderView.id,
        businessId: this.order.payOrderView.id,
        businessType: 'ORDER',
        source: 'PC',
        device: 'PC',
        contractVersionId: this.getPaymentAgId(),
        url: location.origin + '/order/payResult',
        t: new Date().getTime()
      }
      // 支付宝、微信、银联的channel code 传过来的时候是一个值， 给后端的时候是另一个值， 这里处理一下
      const channelMap = {
        'ALIPAY': 'alipay_pc_direct',
        'WECHATPAY': 'wx_pub_qr',
        'UNIONPAY': 'upacp_pc'
      }
      if (Object.keys(channelMap).includes(this.activeChannel.code)) {
        params.channel = channelMap[this.activeChannel.code]
      }

      // 如果是百度金融， 带上用户输入的信息
      params.username = this.activeChannel.username
      params.mobile = this.activeChannel.mobile
      params.email = this.activeChannel.email

      // 如果当前被选中的渠道有分期信息
      if (this.activeChannel.prices && this.activeChannel.prices.length) {
        params.period = this.activeChannel.prices.find(o => {
          return o.checked
        }).period
      }
      return params
    },
    // 交通银行分期 支付
    jtPay() {
      this.payMethod(this.jtPayCallBack)
    },
    // 交通银行分期 支付回调
    jtPayCallBack(res) {
      this.jtForm.OrderCont = res.data.OrderCont
      this.$refs.jtForm.submit()
    },
    // 百度金融分期  支付
    bdPay() {
      this.payMethod(this.bdPayCallBack)
    },
    bdPayCallBack(res) {
      window.location.href = res.data.resultUrl
    },
    // 招商银行分期 支付
    zsInstallmentPay() {
      this.payMethod(this.zsInstallmentPayCallBack)
    },
    // 招商银行分期 支付回调
    zsInstallmentPayCallBack(res) {
      if (res.data && res.data.tagCode) {
        this.showQrModule = true
        this.$nextTick(() => {
          this.$refs.qrCode.creat(res.data.tagCode)
        })
        this.refreshOrderStatus()
        // this.$refs.qrCode.creat(res.data.tagCode, () => {
        //   this.showQrModule = true 
        // })
      }
    },
    // 招商分期二维码返回渠道列表
    goBack() {
      this.showQrModule = false
      clearInterval(this.qrPayCheck)
    },
    // 招行PC扫码
    zsPay() {
      const data = {
        channel: this.activeChannel.code.toLowerCase(), // 后端返回的渠道是大写， 扔过去的时候注意是小写。 我也不知道为啥 ， 原代码就是这样
        payOrderId: this.order.payOrderView.id,
        type: this.order.payOrderView.orderType,
        source: 'pc',
        url: location.origin + '/order/payResult' //TODO: 支付回调page
      }
      // @todo
      this.axios({
        method: 'post',
        url: '/gw/order-rest/api/order_rest/pay/create/charge',
        params: data,
      }).then(res => {
        if (res.data.code === 200 && res.data.data) {
          let channel = res.data.data.channel
          const credential = res.data.data.credential[channel]

          let form = document.createElement('form')
          form.setAttribute('method', 'post')
          form.setAttribute('action', credential.channel_url)
          for (var key in credential) {
            let hiddenField = document.createElement('input')
            hiddenField.setAttribute('type', 'hidden')
            hiddenField.setAttribute('name', key)
            hiddenField.setAttribute('value', credential[key])
            form.appendChild(hiddenField)
          }
          document.body.appendChild(form)
          form.submit()
        } else {
          this.$alert(res.data.msg)
        }
      })
    },
    // 微粒贷
    wldPay() {
      this.payMethod(this.wldPayCallBack)
    },
    // 微粒贷 支付回调
    wldPayCallBack(res) {
      this.showQrModule = true
      this.$nextTick(() => {
        this.$refs.qrCode.creat(res.data.resultUrl)
      })
      this.refreshOrderStatus()
    },
    // 惠民贷
    hmdPay() {
      this.payMethod(this.hmdPayCallBack)
    },
    hmdPayCallBack(res) {
      this.showQrModule = true
      this.$nextTick(() => {
        this.$refs.qrCode.creat(res.data.qrCode)
      })
      this.refreshOrderStatus()
    },
    // 工商 支付
    gsPay() {
      this.payMethod(this.gsPayCallBack)
    },
    // 工商 支付回调
    gsPayCallBack(res) {
      this.gsForm = res.data
      this.$refs.gsForm.submit()
    },
    // 花呗分期
    hbPay() {
      this.payMethod(this.hbPayCallBack)
    },
    // 花呗分期回调
    hbPayCallBack(res) {
      let resultForm = res.data.resultForm //表单字符串原样跳转即可
      let temp = document.querySelector('#hb-form')
      temp.innerHTML = resultForm
      document.querySelector('#hb-form form').submit()
    },
    // 微信支付
    wxPay() {
      this.payMethod(this.wxPayCallBack)
    },
    // 微信支付回调
    wxPayCallBack(res) {
      this.showQrModule = true
      this.$nextTick(() => {
        this.$refs.qrCode.creat(res.data.credential.wx_pub_qr)
      })
      this.refreshOrderStatus()
    },
    // 银联支付
    ylPay() {
      this.windowTager = window.open()
      this.payMethod(this.ylPayCallBack)
    },
    // 银联支付回调
    ylPayCallBack(res) {
      this.pingResult(res)
    },
    // 云闪付
    ysfPay() {
      this.payMethod(this.ysfPayCallBack)
    },
    // 云闪付支付回调，后端返回的是表单
    ysfPayCallBack(res) {
      if (res.data.authCode) {
        let temp = document.querySelector('#hb-form')
        temp.innerHTML = res.data.authCode
        document.querySelector('#hb-form form').submit()
      }
    },
    // 支付宝
    zfbPay() {
      this.windowTager = window.open()
      this.payMethod(this.zfbPayCallBack)
    },
    // 支付宝回调
    zfbPayCallBack(res) {
      if (res.code === 200) {
        if (res.data.provide === 'ALIPAY') {
          this.windowTager.close()
          let temp = document.querySelector('#hb-form')
          temp.innerHTML = res.data.resultForm
          document.querySelector('#hb-form form').submit()
        } else if (res.data.provide === 'AGGREGATION_UNIONPAY') {
          this.zfbQrCode(res.data.qrCode)
        } else if(res.data.provide === 'ZHONGJIN_CLOUDFLASH'){
          // 支付宝中金支付
          this.zfbQrCode(res.data.codeUrl)
        } else {
          this.pingResult(res)
        }
      }
    },
    // Airwallex
    airwallexPay() {
      this.payMethod(this.airwallexPayCallBack)
    },
    airwallexPayCallBack({ data: payData }) {
      console.log("🚀 ~ airwallexPay ~ payData:", payData)

      this.ariwallexPaying = true
      this.airwallexPreparing = true

      let componentNameMap = {
        AIRWALLEX_CARD: "card",
        AIRWALLEX_ALIPAY: "alipaycn",
        AIRWALLEX_WECHAT: "wechatpay",
      }

      loadAirwallex({
        env: "prod", // 'staging | 'demo' | 'prod'
        origin: window.location.origin,
        locale: "zh", // zh or en
      }).then(() => {
        let dropInOptions = {
          intent_id: payData.data.id,
          client_secret: payData.data.client_secret,
          currency: payData.data.currency,
          components: [componentNameMap[payData.provide]], // 只展示对应支付方式的组件
        }
        this.dropInElement = createElement("dropIn", dropInOptions)
        this.dropInElement.mount("dropIn")
        // 监听事件
        const domElement = document.getElementById("dropIn")
        domElement.addEventListener("onReady", this.throttle(this.onAirwallexReady))
        domElement.addEventListener("onSuccess", this.throttle(this.onAirwallexSuccess))
        domElement.addEventListener("onError", this.throttle(this.onAirwallexError))
      })
    },
    onAirwallexReady(e) {
      console.log("onReady", e, this.airwallexPreparing)
      this.airwallexPreparing = false
      setTimeout(() => {
        document.getElementById("dropIn").style.display = "block"
      }, 100)
    },
    onAirwallexSuccess(e) {
      console.log("onSuccess", e)
      this.airwallexPreparing = false
      this.refreshOrderStatus()
    },
    onAirwallexError(e) {
      console.log("onError", e)
      this.$refs.toast.showToast("支付异常,请重试", 3000)
    },
    airwallexBack() {
      this.ariwallexPaying = false
    },
    // 支付宝创建二维码
    zfbQrCode(data){
      this.windowTager.close()
      this.showQrModule = true
      this.$nextTick(() => {
        this.$refs.qrCode.creat(data)
      })
      this.refreshOrderStatus()
    },
    // ping ++  支付方式统一走的逻辑
    pingResult(res) {
      pingpp.setUrlReturnCallback((err, url) => {
        // 阻断 createPayment 的自动调转 ， 否则可能当前再当前页面直接打开， 可能是SPA原因
        this.windowTager.window.location.href = url
      }, ['upacp_pc', 'alipay_pc_direct'])
      pingpp.createPayment(res.data, function (result, err) { })
      this.pingPayResultDialogVisible = true
    },
    refreshOrderStatus() {
      //判断定时请求状态
      this.qrPayCheck = setInterval(() => {
        var flag = true;
        if (flag) {
          this.axios({
            method: 'post',
            url: '/gw/order-rest/api/order_rest/pay/paid/status',
            params: {
              payOrderId: this.order.payOrderView.id,
              _timeStamp: new Date().getTime()
            },
          }).then((res) => {
            if (res.data.code == 200) {
              if (res.data.data.status === 'PAY_CONFIRMED' || res.data.data.status === 'PAID') {
                if (!res.data.data.isShouldShowEgg) {
                  flag = false
                  this.axios({
                    method: 'get',
                    url: '/activity/api/activity/advPosition/getPositionInfoByCode',
                    params: {
                      code: 'banner_pc_paid_popup'
                    }
                  }).then(res => {
                    if (res.data.code === 200) {
                      this.eggsBg = res.data.data[0].imageUrl
                      this.eggsDialogVisible = true
                    }
                  })
                } else {
                  this.$router.push({
                    path: '/order/list'
                  })
                }
                clearInterval(this.qrPayCheck)
              }
            }
          }).catch(err => {
            clearInterval(this.qrPayCheck)
          })
        }
      }, 2000)
    },
    getCityList(){
      this.axios({
        method: 'get',
        url: '/gw/order-rest/api/order_rest/pay/getAreaSubject',
      }).then(res => {
        if (res.data.code === 200) {
          this.cityList = res.data.data
        }
      })
    },
    // 函数节流
    throttle(func, delay = 100) {
      let timer = null
      return function(...args) {
        if (!timer) {
          func.apply(this, args)
          // 设置新的定时器，当定时器到期后，清除定时器标记，这样下次就可以再次触发函数执行了
          timer = setTimeout(() => {
            timer = null
          }, delay)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pay-page-component {
  background-color: #f9f9f9;
  padding-top: 20px;
  padding-bottom: 30px;
  .container-pay-page {
    padding: 0 30px;
    .ipad-info-card {
      margin-bottom: 15px;
      border: 1px solid #e0e0e0;
      background-color: #fff;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
      padding: 15px 25px;
      border-radius: 3px;
      font-size: 14px;
      color: #f60;
    }
  }
  .pay-module {
    height: 56px;
    background-color: #fff;
    text-align: center;
    padding: 10px 0;
    font-size: 14px;
  }
  .airwallex-pay-panel {
    position: relative;
    width: 100%;
    height: auto;
    min-height: 150px;
    border: 1px solid #e0e0e0;
    z-index: 1;
    background-color: #ffffff;
    border-radius: 3px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
    .loading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
    #dropIn {
      padding: 16px;
    }
  }
  .pay-back {
    margin-top: 20px;
    margin-bottom: 100px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    &::before {
      display: inline-block;
      content: "";
      width: 12px;
      height: 12px;
      background: url(/shop/img/bg.2012ba4e.png) no-repeat;
      background-position: -40px 0;
      margin-right: 2px;
    }
  }
  .form-hide {
    display: none;
  }
  .qrcode-container {
    padding: 0 30px;
  }
  .zs-qrcode-module {
    padding: 15px 25px;
    border: 1px solid #e0e0e0;
    margin: 0 auto 15px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    background: #fff;
    .qr-title {
      margin-bottom: 16px;
      font-size: 14px;
      color: #666;
    }
    .qr-content {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 160px;
      .qr-module {
        display: inline-block;
        width: 298px;
        height: 298px;
        background: #fff;
        border: #ddd 1px solid;
        margin: 20px 0;
        padding: 20px;
      }
      .qr-info {
        display: inline-block;
        position: relative;
        width: 300px;
        font-size: 13px;
        background-color: #f60;
        line-height: 22px;
        padding: 8px 0 8px 124px;
        i {
          position: absolute;
          left: 50px;
          top: 8px;
          height: 44px;
          width: 44px;
          background: url("../../../assets/images/order/bg.png") no-repeat -86px
            0;
        }
        span {
          color: #fff;
        }
      }
      .zs-info {
        margin-left: 40px;
        img {
          &.zs-img {
            width: 166px;
            height: 265;
            margin-top: 76px;
          }
          &.wx-img {
            width: 356px;
            height: 480px;
          }
        }
      }
    }
    .go-back {
      display: inline-block;
      position: relative;
      cursor: pointer;
      font-size: 12px;
      color: #333;
      padding: 15px;
      &::before {
        position: absolute;
        content: " ";
        display: inline-block;
        width: 10px;
        height: 12px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: url("../../../assets/images/order/bg.png") no-repeat -40px 0;
      }
    }
  }
}
</style>
